import axios from "@/utils/axios"
import moment from 'moment'
import { DATE_FORMAT, DEFAULT_LIMIT } from "@/utils/config"
import { get_available_taxonomy, get_available_category } from "@/utils/util"
const time = new Date().getTime();
export function getEvents(total = DEFAULT_LIMIT) {
  return axios.get('/events', {
    params: {
      range_start: 0,
      range_total: total,
      start_date: moment().format(DATE_FORMAT),
      taxonomy: get_available_taxonomy(),
      category: get_available_category(),
      tick: time
    }
  });
}
export function getFilteredEvents(start = "", end = "", queryString = "", page = 1, searchTerm = "", limit = DEFAULT_LIMIT) {
  let params = {
    range_start: Math.max(0, (page - 1) * limit),
    range_total: limit,
    tick: time,
  };

  if (start) {
    params.start_date = start;
  }

  if (end) {
    params.end_date = end;
  }

  const available_taxonomy = get_available_taxonomy();
  if (available_taxonomy.length > 0) {
    params.taxonomy = available_taxonomy;
  }

  if (searchTerm) {
    params.s = searchTerm;
  }

  const baseQueryString = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
    const finalQueryString = queryString
    ? `${baseQueryString}&${queryString}`
    : baseQueryString;

  return axios.get(`/events?${finalQueryString}`);
}

export function search(keywords, filters = [], page = 1, limit = DEFAULT_LIMIT) {
  return axios.get('/events', {
    params: {
      range_start: (page - 1) * limit,
      range_total: limit,
      s: keywords,  // Search term
      start_date: moment().format(DATE_FORMAT),
      taxonomy: get_available_taxonomy(),
      category: filters.length ? [...filters, ...get_available_category()] : get_available_category(),  // Filters
      tick: time
    }
  });
}


export function getCategories() {
  return axios.get('/categories', {
    params: {
      taxonomy: get_available_taxonomy(false),
      tick: moment().format("Y-m-d")
    }
  });
}
